import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const BigAbout = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <div className="big-about">
      <div className="item">
        <img
          data-aos="fade-up"
          src="https://cdn.shopify.com/s/files/1/0066/2123/3203/products/Red_Square_Vodka_1024x1024.jpg?v=1657982846"
          alt="vodka"
        />
        <p data-aos="fade-up">
          Past experiences with alcohol help to shape people’s current value and
          the expectations that they place on drinking alcohol. Alcohol users
          may recall their previous positive experiences with alcohol, and this
          may increase their motivation to drink. A negative experience will do
          the opposite. People going through a stressful period in their life
          may value drinking alcohol more highly, because it helps to alleviate
          their negative feelings. The drinking removes, at least temporarily,
          the stress of anxiety. Social norms are the behavioural expectations
          within a community. Alcohol is used at specific events and regular
          times for example, it is expected that alcohol would be served at most
          parties and weddings.
        </p>
      </div>
      <div className="item">
        <img
          data-aos="fade-up"
          src="https://cdn.shopify.com/s/files/1/3026/9496/products/RSFLAVVODKASTRAWBERRY750MLSINGLE6009694722360_A_530x@2x.jpg?v=1615976183"
          alt="vodka"
        />
        <p data-aos="fade-up">
          Exposure to alcohol-related cues increases the craving for alcohol,
          for example TV programmes, advertisements at events etc. On the other
          hand, financial influence, such as taxation, makes drinking less
          attractive. Evidence shows that simply raising the price of an
          alcoholic beverage by 10 percent reduces alcohol consumption by 7
          percent. This is a very simple reason. People drink because alcoholic
          drinks are quite accessible. In most families, drinking alcohol is a
          very common thing among adults. Alcohol is also readily available in
          most supermarkets. Some drink alcohol to be a rebel. They want to defy
          the rules and show that they are different from all the others. This
          is often seen among youngsters especially teenagers who are in the
          process of growing up – the adolescence factor.
        </p>
      </div>
      <div className="item">
        <img
          data-aos="fade-up"
          src="https://www.clickndrink.co.uk/wp-content/uploads/2020/11/35310048.jpg"
          alt="vodka"
        />
        <p data-aos="fade-up">
          Peer pressure is one of the most prominent reasons for drinking among
          people of all categories. Being afraid that you might be isolated or
          discarded from a group of people and doing an activity. Teenagers
          especially are more vulnerable to being affected by this which can
          make them become addicted as they are being pressurised to drink more
          than they want. People generally tend to drink alcohol in order to
          have fun. Being drunk makes them feel happy and “spirited,” and
          drinking alcohol with friends can be a fun experience. If people are
          nervous in social situations, drinking helps them relax and have more
          fun. People drink to have fun at parties, nightclubs, barbecues, and
          more, because they think alcohol enhances their experience.
        </p>
      </div>
      <div className="item">
        <img
          data-aos="fade-up"
          src="https://images.squarespace-cdn.com/content/v1/5c5289e785ede1e279977156/1549354750672-IKN8A5U1PSPZQ9LW13EL/Red+Square+-+Toffee.jpg?format=1000w"
          alt="vodka"
        />
        <p data-aos="fade-up">
          If someone offered you a glass of mild poison, you’d decline. If they
          said “drink this, it’ll make it harder to walk, speak and remember
          things, and you’ll feel awful tomorrow”, you’d be even less keen. If
          they expected payment for it, you might even get annoyed at their
          audacity. You certainly wouldn’t be grateful for it, then buy yourself
          and them several more doses over the course of an evening.
          Nonetheless, this happens all the time. Alcohol does all the things
          described above and more. Nonetheless, many people don’t let that put
          them off. With the festive season kicking off, alcohol consumption
          goes up. The parties (work and otherwise), time-off, social visits,
          the breakfast champagne, and so on. All these “festive tipples” add up
          to an increase in our intake of something that, if the dose is high
          enough, counts as a toxin.
        </p>
      </div>
    </div>
  );
};

export default BigAbout;
